import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router';
import get from 'lodash/get';
import { omit } from 'lodash';
import { isBrandStorePage } from 'utils/miscUtils';

/*
 * A regular expression that greedily matches all browse/search pages that also
 * matches optional query parameter parts
 *
 * (browse_page | q_page | search_page | author_page)
 * browse_page regex matches any `/pr` fragment if:
 * 1. it's at the end of the string OR
 * 2. it ends in a /, or ? plus any data after that
 */
const BrowsePageRegExp = new RegExp(
	/(.+\/pr\/?(?=(\?.+)|$))|(\/q\/[\w-_]+(\?.+)?)|(\/search(\?.+)?)|(\/author\/[\w-_]+(\?.+)?)/
);
const BrandPageRegExp = new RegExp(/(^\/[\w-]+-store(\/?|\/.+|\?.+))/);
const OPListPageRegExp = new RegExp(/((^\/products-list\/.+)|(^\/offers-list\/.+))/);

function UnconnectedABLink(props) {
	const { to, cookieKey, children, ...rest } = props;
	const finalProps = omit(rest, ['dispatch', 'miscState']);
	if (get(props.miscState, ['anchorTagMap', cookieKey])) {
		return (
			<a href={to} {...finalProps}>
				{children}
			</a>
		);
	}

	return (
		<Link to={to} {...finalProps}>
			{children}
		</Link>
	);
}

UnconnectedABLink.propTypes = {
	to: PropTypes.string.isRequired
};

function mapStateToProps(state) {
	return {
		miscState: state.misc
	};
}

export const ABLink = connect(mapStateToProps)(UnconnectedABLink);

function shouldUseReactRouter(toUrl) {
	const matchBrowsePage = BrowsePageRegExp.test(toUrl);
	const matchBrandPage = BrandPageRegExp.test(toUrl);
	const matchOPListPage = OPListPageRegExp.test(toUrl);

	return matchBrowsePage || matchBrandPage || matchOPListPage || isBrandStorePage(toUrl);
}

function ALink(props) {
	const { to, children, ...rest } = props;
	if (shouldUseReactRouter(to)) {
		return (
			<Link to={to} {...rest}>
				{children}
			</Link>
		);
	}

	return (
		<a href={to} {...rest}>
			{children}
		</a>
	);
}

export { ALink as default, shouldUseReactRouter, BrowsePageRegExp };

export function NLink(props) {
	let { newTab = true, children, ...rest } = props;
	rest = omit(rest, ['dispatch']);
	let otherProps = {};

	// This check is for windows app : Opens the Product page in same page, to get the native app experience
	const windowsCheck = window && window.Windows;

	if (newTab && __PROD__ && !windowsCheck) {
		Object.assign(otherProps, {
			target: '_blank',
			rel: 'noopener noreferrer'
		});
	}

	return (
		<Link {...rest} {...otherProps}>
			{children}
		</Link>
	);
}
